module.exports = __webpack_public_path__ + "media/assets/HWE_default_experience-7471d8e6922860e39a4217e518061751.jpg";